import React from 'react';

const EmailDesciption = ({ currentPage, curPage }) => {
    return (
        <>
        <div className=" border p-4 mt-4 h-75 d-flex flex-column row-gap-4" style={{ overflowY: currentPage === curPage ? 'scroll' : '' }}>
            <div className=' d-flex flex-column row-gap-4'>
                <div className=' d-flex m-0' style={{ height: 40 }}>
                    <div className='align-content-center p-0'>
                        <h3 style={{ color: '#214466', fontSize: '16px' }}>Mail Status:</h3>
                    </div>
                    <div className='col-1  align-content-center px-3 mx-3'>
                        <h3 style={{ color: 'black', fontSize: '16px', fontWeight: 600 }}>Replied</h3>
                    </div>
                </div>
                <div className='border border-black row m-0' style={{ height: 350, borderRadius: 7 }}>
                    <div className='col-1 d-flex justify-content-center'>
                        <button className='btn btn-lg border rounded-circle mt-4' style={{ backgroundColor: '#D9D9D9', width: 60, height: 60 }}></button>
                    </div>
                    <div className='col-6 p-0 d-flex flex-column row-gap-4'>
                        <div className=' m-0 d-flex column-gap-4 mt-4'>
                            <h5 className='p-0' style={{ color: '#214466', fontWeight: 600, fontSize: 17.5 }}>Supplier name:</h5>
                            <h5 className='p-0 m-0 align-content-center' style={{ fontSize: 17.5 }}>ABC</h5>
                        </div>
                        <div className='m-0 d-flex column-gap-4'>
                            <h5 className='p-0' style={{ color: '#214466', fontSize: 16 }}>Subject: </h5>
                            <h5 className='p-0 text-black' style={{ fontSize: 16 }}>Supplier Details for your company</h5>
                        </div>
                        <div className='row m-0 d-flex text-black w-75 row-gap-4'>
                            <h5 className='p-0 m-0 ' style={{ fontSize: 16 }}>Dear Madam</h5>
                            <h5 className='p-0' style={{ fontSize: 16 }}>I hope this email finds you well.
                                As requested, please find below the details of our supplier:
                                Supplier Name: [Supplier Name]Contact Person: [Contact Person’s Name]Email Address: [Contact Person’s Email]Phone Number: [Contact Person’s Phone Number]Company Address: [Supplier’s Address]Website: [Supplier’s Website]
                                Products/Services Provided: [Brief description of products or services`]</h5>
                        </div>
                    </div>
                    <div className='col-5 d-flex justify-content-end column-gap-5 mt-4 px-5'>
                        <h3 className='p-0' style={{ color: '#214466', fontWeight: 600, fontSize: 17.5 }}> Date/Time:  </h3>
                        <h3 className='p-0 my-1' style={{ color: 'black', fontSize: 16 }}> {"28/08/2024 @ 07:25 PM"}</h3>
                    </div>
                </div>
            </div>
        </div>
        <div className='d-flex justify-content-end mt-4'>
                <button className="report_button_success">Reply</button>
            </div>
        </>
        
    );
}

export default EmailDesciption;